import { Directive, ElementRef, OnDestroy, OnInit, inject } from '@angular/core';
import { LanguagesService } from '../services/languages.service';
import { CopyToClipboardPlugin } from '../utils/copy-to-clipboard.plugin';

@Directive({
    selector: '[copyOnHover]',
    standalone: true,
})
export class CopyOnHoverDirective implements OnInit, OnDestroy {
    private el = inject(ElementRef);

    private clipboardPlugin: CopyToClipboardPlugin | null = null;
    private languageService = inject(LanguagesService);

    ngOnInit(): void {
        // Get the text content inside the element
        const textToCopy = this.el.nativeElement.textContent.trim();

        // Set the data attribute for ClipboardJS to use
        this.el.nativeElement.setAttribute('data-copy-text', textToCopy);

        // Initialize the clipboard hover plugin
        this.clipboardPlugin = new CopyToClipboardPlugin('[data-copy-text]', this.languageService);
    }

    ngOnDestroy(): void {
        if (this.clipboardPlugin) {
            this.clipboardPlugin.destroy();
        }
    }
}
